import { useAppContextNonNull } from "@contexts/AppContext";
import IOrderUI from "@models/IOrderUI";
import RestEndpointsEnum from "@models/RestEndpointsEnum";
import { buildRestUrl, buildAuthHeadersForFetch } from "@services/RestService";
import React, { useState } from "react";
import { Dropdown } from "react-bootstrap";
import { OwLabel } from "@components/shared/OwLabel/OwLabel";

type Props = {
    order: IOrderUI;
};

type PdfType = "quote" | "sales-order" | "invoice" | "packing-list";

export const OrderEntryDocsDownloadBtnGroup = (props: Props) => {
    const { userModel, supplierModel } = useAppContextNonNull();
    const [downloading, setDownloading] = useState<PdfType | null>(null);

    const downloadPdf = async (pdfType: PdfType) => {
        setDownloading(pdfType);
        try {
            const url = buildRestUrl({
                endpoint: RestEndpointsEnum.PdfDownload,
                params: { orderGuid: props.order.guid, pdfType },
            });

            const headers = buildAuthHeadersForFetch({
                userModel,
                supplierModel,
                includeContentType: false,
            });

            const response = await fetch(url, { method: "GET", headers });

            if (response.ok) {
                const blob = await response.blob();
                const link = document.createElement("a");
                link.href = URL.createObjectURL(blob);
                link.download = `${pdfType}-${props.order.name || props.order.guid}.pdf`;
                link.click();
                URL.revokeObjectURL(link.href);
            }
        } finally {
            setDownloading(null);
        }
    };

    return (
        <Dropdown data-bs-theme="dark" className="OrderEntryDocsDownloadBtnGroup">
            <Dropdown.Toggle size="sm" variant="primary">
                <i className="fad fa-file-pdf me-2" />
                <OwLabel title="pdfs" />
            </Dropdown.Toggle>
            <Dropdown.Menu>
                {props.order.is_quote ? (
                    <Dropdown.Item onClick={() => downloadPdf("quote")} disabled={downloading === "quote"}>
                        <OwLabel title="quote_pdf" />
                    </Dropdown.Item>
                ) : (
                    <>
                        <Dropdown.Item onClick={() => downloadPdf("sales-order")} disabled={downloading === "sales-order"}>
                            <OwLabel title="sales_order_pdf" />
                        </Dropdown.Item>
                        <Dropdown.Item onClick={() => downloadPdf("invoice")} disabled={downloading === "invoice"}>
                            <OwLabel title="invoice_pdf" />
                        </Dropdown.Item>
                        <Dropdown.Item onClick={() => downloadPdf("packing-list")} disabled={downloading === "packing-list"}>
                            <OwLabel title="packing_list_pdf" />
                        </Dropdown.Item>
                    </>
                )}
            </Dropdown.Menu>
        </Dropdown>
    );
};
